import PIEDrawerNotificationReporter from '@src/shared/components/PIEDrawerNotificationReporter';
import React from 'react';

const NotificationDrawer = () => {
  return <PIEDrawerNotificationReporter />;
};

export default NotificationDrawer;
